export default __webpack_public_path__ + "static/digmarks-3a612859e01f701869c5fd9cc5d215fe.png";